import { memo } from "react";
import s from "./PaymentHeader.module.scss";
import { shallow } from "zustand/shallow";
import { useWebUserStore } from "../../../../CommonStores";
import { IonIcon, IonLabel, IonSkeletonText } from "@ionic/react";
import cx from "classnames";
import { format } from "date-fns";
import { calendarOutline } from "ionicons/icons";
import { useBreakpoint } from "../../../../../Common/utils/common";
import { subscriptionCommonStyles } from "../../../../../Common/constants/subscriptionConst";

const PaymentHeader = () => {
  const [user] = useWebUserStore((store) => [store.user], shallow);
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "mobile";

  const { cardIcon, cardStyle } =
    subscriptionCommonStyles[
      (user?.subscription?.name as keyof typeof subscriptionCommonStyles) ||
        "Starter"
    ];

  return user ? (
    <div className={cx(s.header, { [s.mobile]: isMobile })}>
      <div className={s.leftSide}>
        <div className={s.keyValuePair}>
          <IonLabel className={cx(s.key)}>Winners Locker Member:</IonLabel>
          <IonLabel className={cx(s.value)}>
            {user?.firstName} {user?.lastName}
          </IonLabel>
        </div>

        <div className={s.keyValuePair}>
          <div className={s.keyValuePair}>
            <IonLabel className={cx(s.key)}>Subscription Status:</IonLabel>
            <IonLabel className={cx(s.value)}>
              {user?.subscription?.name ?? "-"}
            </IonLabel>
          </div>
          {isMobile ? <></> : <> {"|"}</>}
          <div className={s.keyValuePair}>
            <IonLabel className={cx(s.key)}>Since:</IonLabel>
            <IonLabel className={cx(s.value, s.date)}>
              <IonIcon className={s.icon} src={calendarOutline} />
              {format(user?.dateSubscribed ?? new Date(), "MMMM yyyy")}
            </IonLabel>
          </div>
        </div>
      </div>

      <div className={s.rightSide}>
        <div style={{ ...cardStyle }} className={s.subscriptionIcon}>
          <img src={cardIcon} className={s.logo} alt="" loading="eager" decoding="async" />
        </div>
      </div>
    </div>
  ) : (
    <IonSkeletonText animated />
  );
};

export default memo(PaymentHeader);
